import { extend } from 'vee-validate';

extend('realm', {
    validate(value: any) {
        return value >= 1;
    },
    message: 'Please select a valid realm'
});
